import {useEffect} from 'react'
import {useDispatch} from 'react-redux'

import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

export const FAQPositionViewedTracker = () => {
  const dispatch = useDispatch()
  const {ref, inView} = useInView({triggerOnce: true, threshold: 0.5})

  useEffect(() => {
    if (inView) {
      dispatch(
        trackEvent({
          category: Category.User,
          entity: Entity.HotelDetailsFAQPosition,
          action: Action.Viewed
        })
      )
    }
  }, [dispatch, inView])

  return <div ref={ref} />
}
